import React, { createContext, useState, useContext, useEffect } from 'react';

const LocalizationContext = createContext();

const getDefaultLanguage = () => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) return savedLanguage;

    const browserLanguage = navigator.language.split('-')[0];
    const supportedLanguages = ['en', 'tr'];
    return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en';
};

export const LocalizationProvider = ({ children }) => {
    const [language, setLanguage] = useState(getDefaultLanguage);

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    const changeLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <LocalizationContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LocalizationContext.Provider>
    );
};

export const useLocalization = () => {
    return useContext(LocalizationContext);
};
